import React from "react";
import { useParams, Link } from "react-router-dom";
import UniqueBanner from "../components/UniqueBanner";
import BannerImg from "../assets/Institute/DSC_0575.JPG";
import blogPosts from "../data/blogData";
import "./BlogDetails.css";

const BlogDetails = () => {
  const { slug } = useParams();

  const post = blogPosts.find((p) => p.slug === slug);

  if (!post) {
    return (
      <div className="blog-not-found">
        <h2>Blog Not Found</h2>
        <Link to="/blogs">Back to Blogs</Link>
      </div>
    );
  }

  // Find first title index; if not found, use 0 as first block
  const firstTitleIndex = post.content.findIndex((block) => block.type === "title");
  const hasTitle = firstTitleIndex !== -1;

  // First section blocks
  const firstSection = hasTitle
    ? post.content.slice(firstTitleIndex, post.content.findIndex((b, i) => i > firstTitleIndex && b.type === "title") === -1 ? post.content.length : post.content.findIndex((b, i) => i > firstTitleIndex && b.type === "title"))
    : post.content.slice(0, 1); // if no title, first block only

  // Remaining content after first section
  const startIndex = hasTitle
    ? post.content.findIndex((b, i) => i > firstTitleIndex && b.type === "title") === -1
      ? post.content.length
      : post.content.findIndex((b, i) => i > firstTitleIndex && b.type === "title")
    : 1;

  const remainingContent = post.content.slice(startIndex);

  return (
    <>
      <UniqueBanner
  image={BannerImg}
 title={
  <span
    style={{
      fontSize:
        window.innerWidth <= 576           ? "1.6rem" :      // Mobile
        window.innerWidth <= 992           ? "2rem"   :      // Tablet
                                             "2.5rem",       // Laptop / Desktop
      lineHeight: "1.3"
    }}
  >
    {post.title}
  </span>
}
  subtitle={`Read time: ${post.readTime} min | Views: ${post.views}`}
/>

      <div className="blog-details-container">
        {post.content && post.content.length > 0 ? (
          <>
            {/* --- FIRST SECTION WITH IMAGE --- */}
            <div className="blog-details-first-row">
              <div className="blog-details-left">
                <img src={post.image} alt={post.title} title={post.title} />
              </div>
              <div className="blog-details-right">
                <h3>{hasTitle ? firstSection[0].text : "Introduction"}</h3>
                {firstSection.map((block, i) => {
                  if (hasTitle && block.type === "title") return null; // skip if already shown
                  if (block.type === "paragraph") return <p key={i}>{block.text}</p>;
                  if (block.type === "list")
                    return block.listType === "ol" ? (
                      <ol key={i}>
                        {block.items.map((li, k) => (
                          <li key={k}>{li}</li>
                        ))}
                      </ol>
                    ) : (
                      <ul key={i}>
                        {block.items.map((li, k) => (
                          <li key={k}>{li}</li>
                        ))}
                      </ul>
                    );
                  return null;
                })}
              </div>
            </div>

            {/* --- REMAINING CONTENT FULL WIDTH --- */}
            <div className="blog-details-full-width">
              {remainingContent.map((block, i) => {
                if (block.type === "title") return <h3 key={i}>{block.text}</h3>;
                if (block.type === "paragraph") return <p key={i}>{block.text}</p>;
                if (block.type === "list")
                  return block.listType === "ol" ? (
                    <ol key={i}>
                      {block.items.map((li, k) => (
                        <li key={k}>{li}</li>
                      ))}
                    </ol>
                  ) : (
                    <ul key={i}>
                      {block.items.map((li, k) => (
                        <li key={k}>{li}</li>
                      ))}
                    </ul>
                  );
                return null;
              })}
            </div>
          </>
        ) : (
          <p>No content available for this blog.</p>
        )}

        <Link to="/blogs" className="back-to-blogs">
          ← Back to Blogs
        </Link>
      </div>
    </>
  );
};

export default BlogDetails;
